import { render } from "./AuthenticationFailed.vue?vue&type=template&id=089593ec"
import script from "./AuthenticationFailed.vue?vue&type=script&lang=js"
export * from "./AuthenticationFailed.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__